var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { commonTool } from '../util';
import { defaultPlayerConfig } from './default-player-config';
/**
 * 根据用户传入的配置项生成播放器内部使用的配置项
 */
export function createConfig(userConfig) {
    var _a, _b, _c;
    return __assign(__assign(__assign({ instanceId: commonTool.createGUID() }, defaultPlayerConfig), userConfig), { 
        // origin内核配置上的maxVideoNodeCount已废弃，所以先读播放器config上的maxVideoNodeCount
        maxVideoNodeCount: (_c = (_a = userConfig.maxVideoNodeCount) !== null && _a !== void 0 ? _a : (_b = userConfig.originKernelConfig) === null || _b === void 0 ? void 0 : _b.maxVideoNodeCount) !== null && _c !== void 0 ? _c : defaultPlayerConfig.maxVideoNodeCount });
}
/**
 * 根据用户传入的video标签配置项，转换为生成video标签属性和样式的配置
 * @param videoConfig 用户video标签配置项
 * @returns attrOpts为生成的attribute属性，cssOpts为生成的样式属性
 */
export function convertVideoElementConfig(videoConfig) {
    var presetStyleMap = {
        position: 'absolute',
        width: '100%',
        height: '100%',
        top: 0,
        left: 0,
        objectFit: 'contain',
    };
    var vaildStyleKeys = Object.keys(presetStyleMap);
    var presetAttrMap = {
        playsinline: { playsinline: 'isiPhoneShowPlaysinline', 'webkit-playsinline': 'isiPhoneShowPlaysinline' },
        airplay: { airplay: 'allow', 'x-webkit-airplay': 'allow' },
        crossorigin: { crossOrigin: 'anonymous' },
        'h5-page': { 'x5-video-player-type': 'h5-page' },
    };
    var presetAttrOpts = {
        playsinline: true,
        'h5-page': true,
    };
    Object.keys(videoConfig).forEach(function (key) {
        if (vaildStyleKeys.indexOf(key) === -1) {
            // 不是css属性，才加入
            presetAttrOpts[key] = videoConfig[key];
        }
    });
    var attrOpts = Object.keys(presetAttrOpts).reduce(function (res, key) {
        if (presetAttrMap[key] && typeof presetAttrOpts[key] === 'boolean') {
            // 如果用户传入的key是预设里的某一个，并且为true，我们不添加用户的key而是展开预设内的属性
            res = __assign(__assign({}, res), (presetAttrOpts[key] ? presetAttrMap[key] : {}));
        }
        else {
            // 用户传入了预设参数外的值，直接赋值不做检查
            res[key] = presetAttrOpts[key];
        }
        return res;
    }, {});
    var cssOpts = vaildStyleKeys.reduce(function (res, key) {
        var _a;
        res[key] = (_a = videoConfig[key]) !== null && _a !== void 0 ? _a : presetStyleMap[key];
        return res;
    }, {});
    return {
        attrOpts: attrOpts,
        cssOpts: cssOpts,
    };
}
